import { useAuth } from '../../domains/auth/useAuth'
import { useLocation } from '../../domains/collections/internal/useLocation'

export const useShouldRemoveMerchandisingBanner = () => {
  const { isAuthenticated } = useAuth()
  const { query } = useLocation()
  const isAdminQuery = query && query['preview[auth_user_id]']

  return !isAdminQuery && !isAuthenticated
}
